import React from "react";
import "./WeekendGetawayTrip.css";
import CozyHillStationEscape from "../../assets/CozyHillStationEscape.png";
import BeachsideRelaxation from "../../assets/BeachsideRelaxation.png";
import CountrysideFarmRetreat from "../../assets/CountrysideFarmRetreat.png";
import CityBreakAdventure from "../../assets/CityBreakAdventure.png";
import LakeviewSerenityTrip from "../../assets/LakeviewSerenityTrip.png";
import ForestCampingGetaway from "../../assets/ForestCampingGetaway.png";
import { useNavigate } from "react-router-dom";
const weekendTrips = [
  {
    title: "Cozy Hill Station Escape",
    image: CozyHillStationEscape,
    description:
      "Enjoy a peaceful weekend in a scenic hill station surrounded by cool weather and lush greenery. Relax in cozy cottages, explore nature trails, and unwind with beautiful sunset views for a refreshing short escape.",
    link: "/tour-package-data",
  },
  {
    title: "Beachside Relaxation",
    image: BeachsideRelaxation,
    description:
      "Spend your weekend by the beach enjoying golden sands and calming ocean waves. Take sunset walks, try local seafood, and relax under palm trees for a quick yet rejuvenating coastal getaway.",
    link: "/tour-package-data",
  },
  {
    title: "Countryside Farm Retreat",
    image: CountrysideFarmRetreat,
    description:
      "Escape city life with a charming countryside farm stay filled with fresh air and open fields. Enjoy simple village experiences, outdoor games, and peaceful surroundings during a relaxing weekend retreat.",
    link: "/tour-package-data",
  },
  {
    title: "City Break Adventure",
    image: CityBreakAdventure,
    description:
      "Explore a vibrant city during a short weekend break packed with sightseeing and shopping. Visit famous landmarks, enjoy delicious cuisine, and experience nightlife while creating exciting memories.",
    link: "/tour-package-data",
  },
  {
    title: "Lakeview Serenity Trip",
    image: LakeviewSerenityTrip,
    description:
      "Unwind beside a tranquil lake surrounded by scenic beauty and peaceful vibes. Enjoy boating, nature walks, and relaxing evenings by the water for a calm and refreshing weekend experience.",
    link: "/tour-package-data",
  },
  {
    title: "Forest Camping Getaway",
    image: ForestCampingGetaway,
    description:
      "Reconnect with nature through a short forest camping adventure filled with hiking and campfire nights. Enjoy fresh air, wildlife sounds, and quality time away from daily routine.",
    link: "/tour-package-data",
  },
];

const WeekendGetawayTrip = () => {
  const navigate=useNavigate()
  return (
    <div className="weekend-container">
      <h2 className="weekend-title">Weekend Getaway Packages</h2>

      <div className="weekend-grid">
        {weekendTrips.map((trip, index) => (
          <div
            className="weekend-card"
            key={index}
            onClick={() =>
              navigate(trip.link, {
                state: { title: trip.title },
              })
            }
          >
            <img src={trip.image} alt={trip.title} />
            <div className="weekend-content">
              <h3>{trip.title}</h3>
              <p>{trip.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeekendGetawayTrip;
